import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { APP_RESOURCE } from '../constants';
import apiRoutes from '../../../app/api/routes';

const AppService = ComposedComponent =>
  reduxFetch([
    {
      resource: APP_RESOURCE,
      method: 'get',
      request: (id, rejectCallback, t) => ({
        url: apiRoutes.apps(id),
        meta: {
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getAppFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default AppService;
